import { fromJS } from 'immutable';

export const LOAD_INIT = 'loan/LOAD_INIT';
export const LOAD_SUCCESS = 'loan/LOAD_SUCCESS';
export const LOAD_FAIL = 'loan/LOAD_FAIL';

const ENDPOINT = '/api/loans';

const initialState = {
  offers: fromJS([])
};

export default function loan(state = initialState, { type, payload }) {
  if (type === LOAD_SUCCESS) {
    return {
      ...state,
      offers: fromJS(payload.offers)
    };
  }

  return state;
}

export function getOffers() {
  return {
    types: [LOAD_INIT, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${ENDPOINT}/`)
  };
}

export function isLoaded({ getState }) {
  return getState().loan.offers.size;
}

export function serialize(state) {
  return state.offers.toJS();
}

export function deserialize(state) {
  if (state === null) {
    return initialState;
  }
  return {
    offers: fromJS(state)
  };
}
